import React from "react";
import { Modal, Table, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

const EmployeeFullInfoModal = ({ visible, onClose, employee }) => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    message.success("Copied!");
  };

  const columns = [
    {
      key: "detailName",
      render: (text, record) => record.detailName,
    },
    {
      key: "text",
      render: (text, record) => record.text,
    },
  ];

  const data = [
    {
      detailName: "Name",
      text: employee.fullName,
    },
    {
      detailName: "Email",
      text: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a href={`mailto:${employee.email}`}>{employee.email}</a>
          <CopyOutlined
            onClick={() => handleCopy(employee.email)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    },
    {
      detailName: "Manager",
      text: employee.manager ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          {employee.manager}
        </div>
      ) : null,
    },
    {
      detailName: "Career Coach",
      text: employee.careerCoach ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          {employee.careerCoach}
        </div>
      ) : null,
    },

    {
      detailName: "Level",
      text: `${employee.level} ${employee.levelText} (${employee.levelSource})`,
    },
    {
      detailName: "Practice",
      text: employee.practiceName,
    },
    {
      detailName: "Resource Type",
      text: employee.resourceType,
    },
    {
      detailName: "Psa Instances",
      text: Array.isArray(employee.psaInstances) ? employee.psaInstances.join(", ") : employee.psaInstances,
    },
    {
      detailName: "Primary Psa Instance",
      text: employee.primaryPsaInstance,
    },
    {
      detailName: "ID",
      text: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {employee.id}
          <CopyOutlined
            onClick={() => handleCopy(employee.id)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    },
  ];

  return (
    <Modal
      title="Employee Full Information"
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        rowKey="detailName"
        showHeader={false}
      />
    </Modal>
  );
};

export default EmployeeFullInfoModal;
